export default __webpack_public_path__ + "static/media/replace-starter.2fa082ab.svg";